import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiLinkExternal } from "react-icons/bi";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";
import "./PayHere.css";

function PayHere(props) {

  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [loading, setLoading] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  // Supported devices from backend helper
  const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

  const combinedRef = useRef({});

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value == 1) {
        setFormDataError((prev) => ({
          ...prev,
          test_merchant_id: "",
          test_merchant_secret: ""
        }));
      }
      if (value == 0)
        setFormDataError((prev) => ({
          ...prev,
          live_merchant_id: "",
          live_merchant_secret: ""
        }));
    }
  };

  const handleDeviceChange = (updatedDevices) => {
    // Filter only valid devices and ensure it's an array
    const validDevices = Array.isArray(updatedDevices)
      ? updatedDevices.filter(device => supportedDevices.includes(device))
      : [];

    console.log('Payhere Device change:', { updatedDevices, validDevices, supportedDevices });

    setFormData((prev) => ({
      ...prev,
      supported_devices: validDevices
    }));
  };

  const formValidation = () => {
    let formIsValid = true;
    setFormDataError({}); // Clear previous errors

    // Validate supported devices
    if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
      toast.warning('Please select at least one supported device.');
      formIsValid = false;
    }

    if (formData?.payment_mode == 0) {
      if (!formData?.test_merchant_id) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_merchant_id: "Test Merchant ID cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.test_merchant_secret) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_merchant_secret: "Test Merchant Secret cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.test_api_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_api_key: "Test API Key cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.test_secret_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          test_secret_key: "Test Secret key cannot be empty.",
        }));
        formIsValid = false;
      }
    }
    if (formData?.payment_mode == 1) {
      if (!formData?.live_merchant_id) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_merchant_id: "Live Merchant ID cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.live_merchant_secret) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_merchant_secret: "Live Merchant Secret cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.live_api_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_api_key: "Live API Key cannot be empty.",
        }));
        formIsValid = false;
      }
      if (!formData?.live_secret_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          live_secret_key: "Live Secret key cannot be empty.",
        }));
        formIsValid = false;
      }
    }
    return formIsValid;
  }

  const handleStore = async () => {
    console.log('Payhere Form data before validation:', formData);
    if (formValidation()) {
      setLoading(true)
      const dataToSend = {
        ...formData,
        supported_devices: JSON.stringify(formData.supported_devices || [])
      };
      console.log('Payhere Data being sent:', dataToSend);

      await fetchRequest({
        method: 'POST',
        url: `${process.env.REACT_APP_Baseurl}/admin/payhere_payment/store`,
        params: {},
        data: dataToSend,
      })
        .then(response => {
          if (response?.status) {
            toast.success(response?.message)
            setWithOutRefresh((prev) => !prev)
          }
        }).catch((error => {
          toast.error(error?.response?.data?.message)
        })).finally(() => {
          setLoading(false)
        })
    }
  }

  useEffect(async () => {
    setShowOverlay(true)

    // Fetch supported devices from backend
    try {
      const deviceResponse = await fetchRequest({
        method: 'GET',
        url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
        params: {},
        data: {},
      });

      if (deviceResponse?.status && deviceResponse?.data) {
        setSupportedDevices(deviceResponse.data);
      }
    } catch (error) {
      console.warn('Using default supported devices:', error);
    }

    await fetchRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_Baseurl}/admin/payhere_payment/index`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          const payhereData = response?.payhere_payment;
          let deviceArray = []; // default

          // Parse supported_devices if it exists
          if (payhereData?.supported_devices) {
            try {
              const parsedDevices = typeof payhereData.supported_devices === 'string'
                ? JSON.parse(payhereData.supported_devices)
                : payhereData.supported_devices;
              deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
              console.log('Payhere Loaded devices:', deviceArray);
            } catch (error) {
              console.warn('Invalid supported_devices format:', payhereData.supported_devices);
              deviceArray = [];
            }
          }

          setFormData((prev) => ({
            ...prev,
            ...payhereData,
            supported_devices: deviceArray
          }));
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message)
      })).finally(() => {
        setShowOverlay(false)
      })
  }, [withOutRefresh]);

  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
      <AdminSaveHeader heading={"PayHere Payment"} saveText={"Update PayHere"} saveMethod={handleStore} loading={loading} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="PayHere Configuration" />
            <Link to="https://www.payhere.lk/" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
              <MessageSubHeading text="https://www.payhere.lk/" noMargin />
              <BiLinkExternal className="text-dark ms-2" />
            </Link>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Enable Payment Mode"} />
              </div>
              <div className="col-3 col-md-3 ps-2 text-end">
                <AdminCustomSelect id="payHerePaymentMode" className="payment-mode-custom-select " name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "SANDBOX", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
              </div>
            </div>

            <MessageLabel text={"PayHere Label"} className="" />
            <AdminCustomInput id="payHereLabel" type="text" name="payhere_label" value={formData?.payhere_label} onChange={handleInput} placeHolder={"PayHere Label"} ref={(el) => (combinedRef.current.payhere_label = el)} error={formDataError?.payhere_label} />

            <MessageLabel text={"Currency"} className="" />
            <AdminCustomSelect id="payHereCurrency" className="currency-custom-select" name="currency" value={formData?.currency || 'LKR'} onChange={handleInput} ref={(el) => (combinedRef.current.currency = el)} options={[{ name: "LKR", value: "LKR" }, { name: "USD", value: "USD" }, { name: "EUR", value: "EUR" }]} error={formDataError?.currency} defaultOptionName={""} />
          </Wrapper>

          <Wrapper>
            <DeviceSelector
              selectedDevices={formData?.supported_devices || []}
              onDeviceChange={handleDeviceChange}
              gatewayName="payhere"
              availableDevices={supportedDevices}
              showDescriptions={true}
              label="Supported Devices"
              showSelectAll={true}
              className=""
              cardStyle="default"
              showDeviceStats={true}
            />
          </Wrapper>
        </LeftWrapper>

        <RightWrapper>
          <Wrapper>
            <MessageHeading text="PayHere Merchant Details (SANDBOX)" />
            <MessageLabel text={"Test Merchant ID"} className="" />
            <AdminCustomInput id="payHereTestMerchantId" type="text" name="test_merchant_id" value={formData?.test_merchant_id} onChange={handleInput} placeHolder={"12xxxx3"} ref={(el) => (combinedRef.current.test_merchant_id = el)} error={formDataError?.test_merchant_id} />
            <MessageLabel text={"Test Merchant Secret"} className="" />
            <AdminCustomInput id="payHereTestMerchantSecret" type="text" name="test_merchant_secret" value={formData?.test_merchant_secret} onChange={handleInput} placeHolder={"AxxxxxxxxxxxxxZ"} ref={(el) => (combinedRef.current.test_merchant_secret = el)} error={formDataError?.test_merchant_secret} />
            <MessageLabel text={"Test API Key"} className="" />
            <AdminCustomInput id="payHereTestAPIKey" type="text" name="test_api_key" value={formData?.test_api_key} onChange={handleInput} placeHolder={"AxxxxxxxxxxxxxZ"} ref={(el) => (combinedRef.current.test_api_key = el)} error={formDataError?.test_api_key} />
            <MessageLabel text={"Test Secret Key"} className="" />
            <AdminCustomInput id="payHereTestSecretKey" type="text" name="test_secret_key" value={formData?.test_secret_key} onChange={handleInput} placeHolder={"AxxxxxxxxxxxxxZ"} ref={(el) => (combinedRef.current.test_secret_key = el)} error={formDataError?.test_secret_key} />
          </Wrapper>
          <Wrapper>
            <MessageHeading text="PayHere Merchant Details (LIVE)" />
            <MessageLabel text={"Live Merchant ID"} className="" />
            <AdminCustomInput id="payHereLiveMerchantId" type="text" name="live_merchant_id" value={formData?.live_merchant_id} onChange={handleInput} placeHolder={"12xxxxx4"} ref={(el) => (combinedRef.current.live_merchant_id = el)} error={formDataError?.live_merchant_id} />
            <MessageLabel text={"Live Merchant Secret"} className="" />
            <AdminCustomInput id="payHereLiveMerchantSecret" type="text" name="live_merchant_secret" value={formData?.live_merchant_secret} onChange={handleInput} placeHolder={"AxxxxxxxxxxxxxZ"} ref={(el) => (combinedRef.current.live_merchant_secret = el)} error={formDataError?.live_merchant_secret} />
            <MessageLabel text={"Live API Key"} className="" />
            <AdminCustomInput id="payHereLiveAPIKey" type="text" name="live_api_key" value={formData?.live_api_key} onChange={handleInput} placeHolder={"AxxxxxxxxxxxxxZ"} ref={(el) => (combinedRef.current.live_api_key = el)} error={formDataError?.live_api_key} />
            <MessageLabel text={"Live Secret Key"} className="" />
            <AdminCustomInput id="payHereLiveSecretKey" type="text" name="live_secret_key" value={formData?.live_secret_key} onChange={handleInput} placeHolder={"AxxxxxxxxxxxxxZ"} ref={(el) => (combinedRef.current.live_secret_key = el)} error={formDataError?.live_secret_key} />
          </Wrapper>

        </RightWrapper>
        <AdminCustomButton id="bottomUpdateButton" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update PayHere"} loading={loading} />
      </FormContainer>
    </>
  );
}

export default PayHere;
